<div class="product-info">
      <ul>
          <li *ngIf="produto.duracao != null && produto.duracao != ''">
              <div class="icon">
                  <i [style.color]="color" class="material-icons">schedule</i>
              </div>
              <div class="text">
                  <strong [style.color]="color">Duração</strong>
                  <span>{{produto.duracao | formatDuracao}}</span>
              </div>    
          </li>
          <li>
              <div class="icon">
                  <i [style.color]="color" class="material-icons">confirmation_number</i>
              </div>
              <div class="text">
                  <strong [style.color]="color">Tipo de Atividade</strong>
                  <span>{{categoria.titulo}}</span>
              </div>
          </li>
          <li *ngIf="produto.local_embarque_ativo">
              <div class="icon">
                  <i [style.color]="color" class="material-icons">directions_car_filled</i>
              </div>
              <div class="text">
                  <strong [style.color]="color">Local de Embarque</strong>
                  <span>{{produto.local_embarque}}</span>
              </div>
          </li>
          <li *ngIf="cidades.length > 0">
              <div class="icon">
                  <i [style.color]="color" class="material-icons">place</i>
              </div>
              <div class="text">
                  <strong [style.color]="color">Destinos</strong>  
                  <span *ngFor="let c of cidades">{{c.nome}}</span>
              </div>
          </li>    
      </ul>    
</div> 
 